'use strict';

var log            = require('loglevel');
var config         = require('config');
var _methodFactory = log.methodFactory;

// TODO consider a lib to solve platform inconsistencies the with stack trace
// format, like https://www.stacktracejs.com/#!/docs/stacktrace-js but perhaps
// less retarded (why does their API return promises, why would fetching an
// mother effing stacktrace require an async API?)
function fetchCaller() {
    var webkitRe = /at [^(]+\((.+)\)/;
    var firefoxRe = /[^@]*@(.+)/;
    var stack;
    var matches;

    try { throw new Error(); } catch(er) { stack = er.stack }

    if (typeof stack !== 'string') {
        return 'unknown caller';
    }

    matches = (
        (stack.split('\n')[3] || '').match(webkitRe) ||
        (stack.split('\n')[2] || '').match(firefoxRe)
    );

    return matches ? matches[1] : 'unknown caller';
}

// Append logger name to identify source
log.methodFactory = function(method, level, logger) {
    var raw    = _methodFactory(method, level, logger);

    return function() {
        var args = Array.prototype.slice.call(arguments);
        var caller = fetchCaller();

        args.unshift(caller + ' > ');

        if (logger) {
            args.unshift(logger + ' > ');
        }

        raw.apply(raw, args);
    };
};

// Set log level from env var
log.setLevel(config.logLevel || 'trace');

// Export factory
module.exports = function(logger) {
    if (typeof logger !== 'string') {
        return log;
    }

    return log.getLogger(logger);
}



// WEBPACK FOOTER //
// ./lib/js/log.js